/*!

=========================================================
* Paper Kit React - v1.3.2
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader.js";
// Import the new IndexFooter instead of DemoFooter
import IndexFooter from "components/Footers/IndexFooter.js";

// index sections
// import SectionButtons from "views/index-sections/SectionButtons.js";
// import SectionNavbars from "views/index-sections/SectionNavbars.js"; // Uncomment if needed
// import SectionNavigation from "views/index-sections/SectionNavigation.js"; // Uncomment if needed
// import SectionProgress from "views/index-sections/SectionProgress.js"; // Uncomment if needed
// import SectionNotifications from "views/index-sections/SectionNotifications.js"; // Uncomment if needed
// import SectionTypography from "views/index-sections/SectionTypography.js"; // Uncomment if needed
// import SectionJavaScript from "views/index-sections/SectionJavaScript.js"; // Uncomment if needed
import SectionCarousel from "views/index-sections/SectionCarousel.js";
import SectionNucleoIcons from "views/index-sections/SectionNucleoIcons.js";
// import SectionDark from "views/index-sections/SectionDark.js"; // Uncomment if needed
import SectionLogin from "views/index-sections/SectionLogin.js";
// import SectionExamples from "views/index-sections/SectionExamples.js"; // Uncomment if needed
import SectionDownload from "views/index-sections/SectionDownload.js";



function Index() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("index");
    return function cleanup() {
      document.body.classList.remove("index");
    };
  });
  return (
    <>
      <IndexNavbar />
      <IndexHeader />
      <div className="main">
        {/* Commented out sections can be re-enabled if needed */}
        {/* <SectionButtons /> */}
        {/* <SectionNavbars /> */}
        {/* <SectionNavigation /> */}
        {/* <SectionProgress /> */}
        {/* <SectionNotifications /> */}
        {/* <SectionTypography /> */}
        {/* <SectionJavaScript /> */}
        <SectionCarousel />
        <SectionNucleoIcons />
        {/*<SectionDark />*/}
        <SectionLogin />
        <SectionDownload />
        {/* Use the new IndexFooter component */}
        <IndexFooter />
      </div>
    </>
  );
}

export default Index;